import { render, staticRenderFns } from "./FormAttributeDefinitionTable.global.vue?vue&type=template&id=4a6f246c&lang=pug&"
import script from "./FormAttributeDefinitionTable.global.vue?vue&type=script&lang=ts&"
export * from "./FormAttributeDefinitionTable.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports